import { message } from 'antd';

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
  message.success('Pozytywnie skopiowano do schowka');
};

export default copyToClipboard;
